export default "__VITE_ASSET__pmCIa0iM__"